export default function getCallbackFromProps(props) {
  return props.onSubscriptionRequest;
}
